import React from "react";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import Services from "../components/Services";
import Benefits from "../components/Benefits";
import Process from "../components/Process";
import Experience from "../components/Experience";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";

const HomePage = () => {
  return (
    <>
      <Hero />
      <AboutUs />
      <Services />
      <Benefits />
      <Process />
      <Experience />
      <Testimonials />
      <Contact />
    </>
  );
};

export default HomePage;
